"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LineChartSVG = void 0;

var _palette = require("@artsy/palette");

var _d3Interpolate = require("d3-interpolate");

var _d3Shape = require("d3-shape");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Line = require("./Line");

var _Point = require("./Point");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Component rendering the SVG part of the line chart (e.g line and points)
 */
var LineChartSVG = function LineChartSVG(_ref) {
  var width = _ref.width,
      height = _ref.height,
      margin = _ref.margin,
      points = _ref.points,
      hoverIndex = _ref.hoverIndex;
  var values = points.map(function (d) {
    return d.value;
  });
  var maxValue = Math.max.apply(Math, _toConsumableArray(points.map(function (_ref2) {
    var value = _ref2.value;
    return value;
  })));
  var zeros = values.map(function () {
    return 0;
  });
  var valuesInterpolator = (0, _d3Interpolate.interpolateArray)(zeros, values);
  var w = width - 2 * margin;
  var h = height - 2 * margin; // maps value to x/y position

  var displayYPosition = function displayYPosition(d) {
    return maxValue ? h - d * h / maxValue : h;
  };

  var displayXPosition = function displayXPosition(_d, i) {
    return i / (points.length - 1) * w;
  };

  var line = (0, _d3Shape.line)().x(displayXPosition).y(displayYPosition);
  var interpolatedValues = valuesInterpolator(1);
  return /*#__PURE__*/_react.default.createElement(Svg, {
    width: width,
    height: height
  }, /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(0, ".concat(margin, ")")
  }, /*#__PURE__*/_react.default.createElement("line", {
    stroke: (0, _palette.color)("black10"),
    x1: "0",
    x2: width,
    y1: h,
    y2: h
  }), /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(".concat(margin, ", 0)")
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Line.Line, {
    path: line(interpolatedValues)
  }), interpolatedValues.map(function (value, index) {
    return /*#__PURE__*/_react.default.createElement(_Point.Point, {
      hovered: hoverIndex === index,
      key: index,
      opacity: 1,
      cx: displayXPosition(value, index),
      cy: displayYPosition(value)
    });
  })))));
};

exports.LineChartSVG = LineChartSVG;
LineChartSVG.displayName = "LineChartSVG";

var Svg = _styledComponents.default.svg.withConfig({
  displayName: "LineChartSVG__Svg",
  componentId: "sc-112gtml-0"
})(["position:absolute;"]);
//# sourceMappingURL=LineChartSVG.js.map